/**
 * @generated SignedSource<<627006469ceef078dbf515e74e63a938>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AssignHotelInput = {
  externalId?: string | null;
  internalId?: string | null;
};
export type AssignHotelToPackageDialogMutation$variables = {
  id: string;
  input: AssignHotelInput;
};
export type AssignHotelToPackageDialogMutation$data = {
  readonly assignHotelToPackage: {
    readonly " $fragmentSpreads": FragmentRefs<"PackageEditAccommodation_package">;
  };
};
export type AssignHotelToPackageDialogMutation = {
  response: AssignHotelToPackageDialogMutation$data;
  variables: AssignHotelToPackageDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "nameString",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "capacity",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignHotelToPackageDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Package",
        "kind": "LinkedField",
        "name": "assignHotelToPackage",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PackageEditAccommodation_package"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssignHotelToPackageDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Package",
        "kind": "LinkedField",
        "name": "assignHotelToPackage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Hotel",
            "kind": "LinkedField",
            "name": "hotel",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "destination",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Media",
                "kind": "LinkedField",
                "name": "mainMedia",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "size",
                        "value": "S120X120"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "externalUrl",
                    "storageKey": "externalUrl(size:\"S120X120\")"
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "size",
                        "value": "w262"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "src",
                    "storageKey": "src(size:\"w262\")"
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Text",
                "kind": "LinkedField",
                "name": "descriptionText",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TextBlock",
                    "kind": "LinkedField",
                    "name": "activeBlock",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "data",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 2147483647
                  }
                ],
                "concreteType": "RoomConnection",
                "kind": "LinkedField",
                "name": "rooms",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoomEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Room",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v4/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "rooms(first:2147483647)"
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CateringOption",
            "kind": "LinkedField",
            "name": "cateringOptions",
            "plural": true,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Room",
            "kind": "LinkedField",
            "name": "rooms",
            "plural": true,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GroupedRate",
            "kind": "LinkedField",
            "name": "groupedRates",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PackageDate",
                "kind": "LinkedField",
                "name": "date",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "start",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "end",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Flight",
                    "kind": "LinkedField",
                    "name": "flight",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "priceLive",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RateByCatering",
                "kind": "LinkedField",
                "name": "ratesByCatering",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CateringOption",
                    "kind": "LinkedField",
                    "name": "cateringOption",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "etgKey",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RateByRoom",
                    "kind": "LinkedField",
                    "name": "ratesByRoom",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Room",
                        "kind": "LinkedField",
                        "name": "room",
                        "plural": false,
                        "selections": (v4/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoomRate",
                        "kind": "LinkedField",
                        "name": "roomRate",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "roomPriceAdult",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tripPriceAdult",
                            "storageKey": null
                          },
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "priceNett",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "roomPriceChild",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tripPriceChild",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baseCostAdult",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baseCostChild",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isPercentMarkup",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "markupPercentAdult",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "markupPercentChild",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "markupAmountAdult",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "markupAmountChild",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__id",
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "transferPrice",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3bda53faeb141d977d9728658fb5e4a2",
    "id": null,
    "metadata": {},
    "name": "AssignHotelToPackageDialogMutation",
    "operationKind": "mutation",
    "text": "mutation AssignHotelToPackageDialogMutation(\n  $id: ID!\n  $input: AssignHotelInput!\n) {\n  assignHotelToPackage(id: $id, input: $input) {\n    ...PackageEditAccommodation_package\n    id\n  }\n}\n\nfragment AssignHotelToPackageDialog_package on Package {\n  id\n}\n\nfragment CateringOptionName_cateringOption on CateringOption {\n  name\n  etgKey\n}\n\nfragment MediaThumb_media on Media {\n  type\n  externalUrl(size: S120X120)\n  src(size: w262)\n}\n\nfragment PackageEditAccommodation_package on Package {\n  hotel {\n    id\n  }\n  ...PackageEditAccomodationHotel_package\n  ...PackageEditAccomodationPrices_package\n  ...AssignHotelToPackageDialog_package\n}\n\nfragment PackageEditAccomodationHotel_package on Package {\n  id\n  hotel {\n    id\n    name\n    destination\n    mainMedia {\n      ...MediaThumb_media\n      id\n    }\n    descriptionText {\n      activeBlock {\n        data\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment PackageEditAccomodationPrices_package on Package {\n  cateringOptions {\n    id\n  }\n  rooms {\n    id\n  }\n  ...RoomRatesTable_package\n  ...RoomRatesEditorInit_package\n  ...RoomRatesToolbar_package\n}\n\nfragment RoomNameWithCapacity_room on Room {\n  nameString\n  capacity\n}\n\nfragment RoomRatesEditorCateringSettings_package on Package {\n  id\n  cateringOptions {\n    id\n  }\n}\n\nfragment RoomRatesEditorInit_package on Package {\n  cateringOptions {\n    id\n  }\n  rooms {\n    id\n  }\n  ...RoomRatesEditorRoomSettings_package\n  ...RoomRatesEditorCateringSettings_package\n}\n\nfragment RoomRatesEditorRoomSettings_package on Package {\n  id\n  hotel {\n    id\n    rooms(first: 2147483647) {\n      edges {\n        node {\n          id\n          nameString\n          ...RoomNameWithCapacity_room\n        }\n      }\n    }\n  }\n  rooms {\n    id\n  }\n}\n\nfragment RoomRatesEditorSettingsMenuCatering_package on Package {\n  ...RoomRatesEditorCateringSettings_package\n}\n\nfragment RoomRatesEditorSettingsMenuRooms_package on Package {\n  ...RoomRatesEditorRoomSettings_package\n}\n\nfragment RoomRatesEditorSettingsMenu_package on Package {\n  ...RoomRatesEditorSettingsMenuRooms_package\n  ...RoomRatesEditorSettingsMenuCatering_package\n}\n\nfragment RoomRatesTableDateRow_groupedRate on GroupedRate {\n  date {\n    id\n    start\n    end\n    ...RoomRatesTableRateCell_packageDate\n  }\n  ratesByCatering {\n    cateringOption {\n      id\n      ...CateringOptionName_cateringOption\n      ...RoomRatesTableRateCell_cateringOption\n    }\n    ratesByRoom {\n      ...RoomRatesTableRateCell_rateByRoom\n    }\n  }\n}\n\nfragment RoomRatesTableDateRow_package on Package {\n  ...RoomRatesTableRateCell_package\n}\n\nfragment RoomRatesTableHead_package on Package {\n  rooms {\n    id\n    ...RoomNameWithCapacity_room\n  }\n}\n\nfragment RoomRatesTableRateCellValue_roomRate on RoomRate {\n  roomPriceAdult\n  tripPriceAdult\n}\n\nfragment RoomRatesTableRateCell_cateringOption on CateringOption {\n  id\n  ...RoomRatesTableRateEditor_cateringOption\n}\n\nfragment RoomRatesTableRateCell_package on Package {\n  ...RoomRatesTableRateEditor_package\n}\n\nfragment RoomRatesTableRateCell_packageDate on PackageDate {\n  id\n  ...RoomRatesTableRateEditor_packageDate\n}\n\nfragment RoomRatesTableRateCell_rateByRoom on RateByRoom {\n  room {\n    id\n  }\n  roomRate {\n    ...RoomRatesTableRateCellValue_roomRate\n    id\n  }\n  ...RoomRatesTableRateEditor_rateByRoom\n}\n\nfragment RoomRatesTableRateEditorForm_cateringOption on CateringOption {\n  id\n  ...CateringOptionName_cateringOption\n}\n\nfragment RoomRatesTableRateEditorForm_package on Package {\n  transferPrice\n}\n\nfragment RoomRatesTableRateEditorForm_packageDate on PackageDate {\n  id\n  start\n  end\n  flight {\n    priceLive\n    id\n  }\n}\n\nfragment RoomRatesTableRateEditorForm_rateByRoom on RateByRoom {\n  room {\n    ...RoomNameWithCapacity_room\n    id\n  }\n  roomRate {\n    ...RoomRatesTableRateEditorPriceBreakdown_roomRate\n    id\n  }\n}\n\nfragment RoomRatesTableRateEditorPriceBreakdown_roomRate on RoomRate {\n  tripPriceAdult\n  tripPriceChild\n  baseCostAdult\n  baseCostChild\n  isPercentMarkup\n  markupPercentAdult\n  markupPercentChild\n  markupAmountAdult\n  markupAmountChild\n}\n\nfragment RoomRatesTableRateEditor_cateringOption on CateringOption {\n  id\n  ...RoomRatesTableRateEditorForm_cateringOption\n}\n\nfragment RoomRatesTableRateEditor_package on Package {\n  ...RoomRatesTableRateEditorForm_package\n}\n\nfragment RoomRatesTableRateEditor_packageDate on PackageDate {\n  id\n  ...RoomRatesTableRateEditorForm_packageDate\n}\n\nfragment RoomRatesTableRateEditor_rateByRoom on RateByRoom {\n  room {\n    id\n  }\n  roomRate {\n    id\n    priceNett\n    roomPriceAdult\n    roomPriceChild\n  }\n  ...RoomRatesTableRateEditorForm_rateByRoom\n}\n\nfragment RoomRatesTable_package on Package {\n  groupedRates {\n    date {\n      id\n    }\n    ...RoomRatesTableDateRow_groupedRate\n  }\n  ...RoomRatesTableHead_package\n  ...RoomRatesTableDateRow_package\n}\n\nfragment RoomRatesToolbar_package on Package {\n  ...RoomRatesEditorSettingsMenu_package\n}\n"
  }
};
})();

(node as any).hash = "e22669250e57b4a4e5ba34edde5e286f";

export default node;
